import Cookies from 'js-cookie'

// Раньше здесь при отсутствующем accessToken запускался «fire-and-forget» вызов
// AuthService.getNewTokens() — но функция синхронная, результат нового токена
// применить было некуда: текущий запрос всё равно уходил без Authorization и
// получал 401. При этом такой незасинхронизированный вызов мог race'иться с
// обновлением токена из axios-интерцептора (см. interceprots.ts) и досрочно
// сжигать ротируемый refresh_token. Отдаём всю логику обновления интерцептору —
// здесь просто отдаём то, что есть в куках.
export const getAccessToken = (can_authorized?: boolean) => {
	return Cookies.get('accessToken') || null
}

// Бэкенд отдаёт expires_in только для access_token (сек, OAuth-конвенция);
// отдельного TTL для refresh_token ответ не содержит, поэтому держим его
// кукой фиксированной длительности. isAuth/userId/email — вспомогательные
// метки наличия сессии и не должны протухать раньше refreshToken, иначе UI
// считает пользователя разлогиненным, хотя сессию ещё можно обновить
// (см. историю такого бага в components/header.tsx).
const REFRESH_TOKEN_TTL_DAYS = 30
const DEFAULT_ACCESS_TOKEN_TTL_SECONDS = 60 * 60

interface AuthTokensResponse {
	access_token: string
	refresh_token: string
	user_id: string | number
	// Telegram-аккаунты (бот/сайт-через-Telegram/Mini App) могут не иметь
	// email вообще — подтверждено живым вызовом бэкенда (email: null).
	email: string | null
	expires_in?: number
}

export const setAuthCookies = (data: AuthTokensResponse) => {
	const accessTokenTtlDays =
		(data.expires_in || DEFAULT_ACCESS_TOKEN_TTL_SECONDS) / 86400

	Cookies.set('accessToken', data.access_token, { expires: accessTokenTtlDays })
	Cookies.set('refreshToken', data.refresh_token, { expires: REFRESH_TOKEN_TTL_DAYS })
	Cookies.set('userId', String(data.user_id), { expires: REFRESH_TOKEN_TTL_DAYS })
	Cookies.set('isAuth', 'true', { expires: REFRESH_TOKEN_TTL_DAYS })
	// Нет email — не пишем куку строкой "null", просто не выставляем её
	// (Cookies.get('email') останется undefined, а не литералом "null").
	if (data.email) {
		Cookies.set('email', data.email, { expires: REFRESH_TOKEN_TTL_DAYS })
	} else {
		Cookies.remove('email')
	}
}

export const clearAuthCookies = () => {
	Cookies.remove('accessToken')
	Cookies.remove('refreshToken')
	Cookies.remove('userId')
	Cookies.remove('isAuth')
	Cookies.remove('email')
}
